module.exports = __webpack_public_path__ + "static/sulekha-bdc4151b1afb11cdbd16f644ce5a7dae.png";